import { MdDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { Observable } from 'rxjs/Observable';
import { WarmUpService } from 'app/services/warmup/warmup.service';
import { OnInit, Component, ChangeDetectorRef } from '@angular/core';
import { PoliticallyExposedService } from './../politically-exposed.service';
import { PepMatchRecord, PepEntity } from './../../pep-match.model';
import { SnackBarService } from 'app/services/snackbar.service';
import { MessageService } from 'app/services/messages.service';

@Component({
  templateUrl: './resolve-pepmatch.component.html',
})

/**
 * Dialog component to resolve pep match.
 *
 * @author jagpreet.singh@vernuso.com  (Jagpreet Singh)
 */
export class ResolvePepMatchComponent implements OnInit {
  resolveForm: FormGroup;
  pepMatchRecord: PepMatchRecord;
  relationEntityId: number;
  matchResolutions: ApplicationValue[];
  selectedMatchResolution: string;
  falseMatchReasons: ApplicationValue[];
  formErrors = {
    'matchResolution': '',
  };

  validationMessages = {
    'matchResolution': {
      'required': 'Required field value.',
    },
  };

  constructor(private pepService: PoliticallyExposedService,
    private warmUpService: WarmUpService,
    private cdr: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<any>,
    private snackBarService: SnackBarService) { }

  ngOnInit() {
    this.buildForm();
    this.setUpMatchResolutions(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.SANCTION_MATCH_RESOLUTION));
    this.setUpFalseMatchReasons(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.FALSE_MATCH_REASONS));
    this.populateForm();
  }

  // @todo This function might get updated once REST is available.
  buildForm() {
    this.resolveForm = this.formBuilder.group({
      matchResolution: ['', Validators.required],
      comments: [''],
      falseMatch: [''],
    });
    this.onValueChanged();
  }

  onValueChanged(data?: any) {
    if (!this.resolveForm) {
      return;
    }
    const form = this.resolveForm;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && control.touched && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] += messages[key] + ' ';
        }
      }
    }
  }

  populateForm() {
    if (this.pepMatchRecord) {
      this.resolveForm.patchValue({
        matchResolution: this.pepMatchRecord.matchResolution,
        comments: this.pepMatchRecord.comments,
        falseMatch: this.pepMatchRecord.falseMatchReason,
      });
      this.selectedMatchResolution = this.pepMatchRecord.matchResolution.toString();
    }
  }

  setUpMatchResolutions(dropDownValues: any) {
    if (dropDownValues instanceof Observable) {
      dropDownValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.matchResolutions = response.values;
          this.cdr.detectChanges();
        }
      );
    } else {
      this.matchResolutions = dropDownValues;
    }
  }

  setUpFalseMatchReasons(dropDownValues: any) {
    if (dropDownValues instanceof Observable) {
      dropDownValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.falseMatchReasons = response.values;
          this.cdr.detectChanges();
        }
      );
    } else {
      this.falseMatchReasons = dropDownValues;
    }
  }

  selectMatchResolution(event) {
    this.selectedMatchResolution = event.value;
  }

  isSelectedMatchFalse(): boolean {
    if (this.matchResolutions) {
      const falseMatchId = this.matchResolutions.find(matchResolution => matchResolution.name === 'False').id;
      return this.selectedMatchResolution == falseMatchId.toString();
    }
    return false;
  }

  onSubmit({ value, valid }) {
    const pepMatchRecord = new PepMatchRecord();
    pepMatchRecord.pepEntity = this.pepMatchRecord.pepEntity;
    pepMatchRecord.relationEntityId = this.relationEntityId;
    pepMatchRecord.matchResolution = value.matchResolution;
    pepMatchRecord.falseMatchReason = value.falseMatch;
    pepMatchRecord.comments = value.comments;
    this.pepService.markPepResolve(pepMatchRecord).subscribe(response => {
      if (response.flagResult) {
        this.dialogRef.close(pepMatchRecord);
      }
      this.callSnackBarService(response);
    }, err => {
      this.callSnackBarService(err);
    });
  }

  callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response,
        MessageService.PEP_RESOLVE_SUCCESS,
        MessageService.PEP_RESOLVE_FAILURE);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/politicallyexposed/resolvepepmatch/resolve-pepmatch.component.ts